import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationShippingAddressEditPage } from 'src/app/modals/organisation-shipping-address-edit/organisation-shipping-address-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationShippingAddressEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationShippingAddressEditPage]
})
export class OrganisationShippingAddressEditPageModule {}
